import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { AppDispatch } from 'store';
import { addTask, idleAllPlannedTasksAction } from 'store/tasksThunks';
import { selectWorkspaceId } from 'store/userSlice';

import AddTask from 'containers/Plan/AddTask';
import Button from 'layout/atoms/Button';
import Container from 'layout/atoms/Container';
import Dropdown from 'layout/atoms/Dropdown';

import { ReactComponent as MoveBackIcon } from 'assets/icons/arrow-up-left.svg';

export const TaskQuickAdd = ({
    plannedTasksLength,
}: {
    plannedTasksLength: number;
}) => {
    const dispatch = useDispatch<AppDispatch>();
    const { t } = useTranslation();
    const workspaceId = useSelector(selectWorkspaceId) || '';

    const idleAllPlannedTasks = () => {
        dispatch(idleAllPlannedTasksAction());
    };

    const onQuickTasksAdded = async (tasks: string[]) => {
        for (let i = 0; i < tasks.length; i++) {
            const t = tasks[i];
            await dispatch(
                addTask({
                    workspaceId: workspaceId,
                    projectId: workspaceId,
                    name: t,
                    planned: true,
                })
            );
        }
    };

    return (
        <Container size="s">
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent:
                        plannedTasksLength > 0 ? 'space-between' : 'flex-start',
                }}
            >
                <AddTask
                    buttonText={t('EXECUTE.QUICK_ADD')}
                    placeholder={t('TASK.ADD_TASK_PLACEHOLDER')}
                    onTasksAdded={onQuickTasksAdded}
                />
                {plannedTasksLength > 0 && (
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-end',
                        }}
                    >
                        <Dropdown position="bottomRight" horizontal={true}>
                            <Button onClick={idleAllPlannedTasks}>
                                <MoveBackIcon style={{ display: 'inline' }} />
                                <span style={{ marginLeft: '6px' }}>
                                    {t('EXECUTE.MOVE_ALL_TO_PLANNING')}
                                </span>
                            </Button>
                        </Dropdown>
                    </div>
                )}
            </div>
        </Container>
    );
};

export default TaskQuickAdd;
